import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { Divider, List, Typography } from '@mui/material';
import NavItem from '../NavItem';
import NavCollapse from '../NavCollapse';
import useSidebarCollapsed from '../../useSidebarCollapsed';

const NavGroup = ({ item }) => {
  const theme = useTheme();
  const collapsed = useSidebarCollapsed();

  const items = (item?.children || []).filter(Boolean).map((menu) => {
    switch (menu.type) {
      case 'collapse':
        return <NavCollapse key={menu.id} menu={menu} level={1} />;
      case 'item':
        return <NavItem key={menu.id} item={menu} level={1} />;
      default:
        return (
          <Typography key={menu.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  if (!item) return null;

  return (
    <>
      <List
        disablePadding
        sx={{ pt: collapsed ? 0.5 : 1, pb: collapsed ? 0.5 : 1.5 }}
        subheader={
          item.title &&
          !collapsed && (
            <Typography
              component="div"
              sx={{
                fontSize: '0.71875rem',
                fontWeight: 600,
                letterSpacing: '0.06em',
                textTransform: 'uppercase',
                color: 'text.disabled',
                px: '10px',
                pb: '6px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}
            >
              {item.title}
              {item.caption && (
                <Typography
                  component="span"
                  variant="caption"
                  sx={{ ...theme.typography.subMenuCaption, display: 'block', letterSpacing: 0 }}
                >
                  {item.caption}
                </Typography>
              )}
            </Typography>
          )
        }
      >
        {items}
      </List>

      {collapsed && <Divider sx={{ my: 0.5, mx: 1 }} />}
    </>
  );
};

NavGroup.propTypes = {
  item: PropTypes.object
};

export default NavGroup;